import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { api } from "../../lib/site";
import { Overline } from "./Primitives";

const EASE = [0.16, 1, 0.3, 1];

export const Testimonials = ({ heading = "Student & client success" }) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/testimonials").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <section data-testid="testimonials-section" className="bg-brand-cream py-24 md:py-36">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="text-center flex flex-col items-center mb-16">
          <Overline className="mb-5">Testimonials</Overline>
          <h2 className="font-serif font-light text-brand-ink text-4xl sm:text-5xl lg:text-6xl tracking-tight max-w-2xl">
            {heading}
          </h2>
        </div>
        <div className="grid gap-6 md:grid-cols-3">
          {items.map((t, i) => (
            <motion.figure
              key={t.id}
              data-testid={`testimonial-${t.id}`}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, ease: EASE, delay: i * 0.1 }}
              className="bg-white rounded-3xl border border-brand-ink/10 p-8 md:p-9 flex flex-col"
            >
              <div className="flex gap-1 text-brand-gold mb-5">
                {[...Array(5)].map((_, k) => <Star key={k} size={15} fill="currentColor" />)}
              </div>
              <blockquote className="font-serif italic text-xl md:text-2xl text-brand-ink leading-snug flex-1">
                “{t.quote}”
              </blockquote>
              <figcaption className="flex items-center gap-4 mt-7 pt-6 border-t border-brand-ink/10">
                <img src={t.image} alt={t.name} className="h-12 w-12 rounded-full object-cover" />
                <div>
                  <p className="font-medium text-brand-ink">{t.name}</p>
                  <p className="text-sm text-brand-ink/55">{t.role}</p>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
